import { defineMessages } from 'react-intl';

/** Shared copy for the "transcript deleted" block (tooltip + toast). */
export const transcriptDeletedMessages = defineMessages({
  blockedToastTitle: {
    defaultMessage: 'Transcript deleted',
    id: 'OzuoQFEm9r',
    description:
      'Toast title shown when a user tries to generate or regenerate a note or document after the transcript has been deleted.',
  },
  blockedToastDescription: {
    defaultMessage:
      'This transcript has been deleted, so notes and documents can no longer be generated.',
    id: 'yMUMofyM5M',
    description:
      'Toast body explaining why note/document generation is blocked after transcript deletion.',
  },
  blockedTooltip: {
    defaultMessage:
      'This transcript was deleted. Notes and documents can no longer be generated.',
    id: 'NuCdu86lkM',
    description:
      'Tooltip on a disabled regenerate/generate control explaining why it is unavailable after transcript deletion.',
  },
});
